import { SVGProps } from "react";

export default function H2Icon(props: SVGProps<SVGSVGElement>) {
  const { width = 12, height = 13, ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 2.125C1.7071 2.125 1.875 2.2929 1.875 2.5V10.5C1.875 10.7071 1.7071 10.875 1.5 10.875C1.2929 10.875 1.125 10.7071 1.125 10.5V2.5C1.125 2.2929 1.2929 2.125 1.5 2.125Z"
        fill="#545454"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2.125C6.2071 2.125 6.375 2.2929 6.375 2.5V10.5C6.375 10.7071 6.2071 10.875 6 10.875C5.7929 10.875 5.625 10.7071 5.625 10.5V2.5C5.625 2.2929 5.7929 2.125 6 2.125Z"
        fill="#545454"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.375 6.5C1.375 6.2929 1.5429 6.125 1.75 6.125H5.75C5.9571 6.125 6.125 6.2929 6.125 6.5C6.125 6.7071 5.9571 6.875 5.75 6.875H1.75C1.5429 6.875 1.375 6.7071 1.375 6.5Z"
        fill="#545454"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.25 5.875C8.83205 5.875 8.375 6.20485 8.375 6.75C8.375 6.9571 8.2071 7.125 8 7.125C7.7929 7.125 7.625 6.9571 7.625 6.75C7.625 5.71185 8.5013 5.125 9.25 5.125C9.99875 5.125 10.875 5.71185 10.875 6.75C10.875 7.21905 10.6691 7.6301 10.4117 7.98085C10.1552 8.3304 9.8191 8.65735 9.50995 8.95465C9.4939 8.9701 9.47795 8.9854 9.46205 9.0007C9.16115 9.2899 8.88955 9.5509 8.686 9.81115C8.5975 9.92425 8.5292 10.0283 8.47945 10.125H10.5C10.7071 10.125 10.875 10.2929 10.875 10.5C10.875 10.7071 10.7071 10.875 10.5 10.875H8C7.7929 10.875 7.625 10.7071 7.625 10.5C7.625 10.0589 7.84175 9.6731 8.09525 9.349C8.333 9.04515 8.64125 8.7491 8.9295 8.47225C8.9498 8.45275 8.97 8.43335 8.99005 8.4141C9.3059 8.11035 9.5948 7.8264 9.80705 7.53715C10.0184 7.24905 10.125 6.99345 10.125 6.75C10.125 6.20485 9.66795 5.875 9.25 5.875Z"
        fill="#545454"
      />
    </svg>
  );
}
